/* eslint-disable no-case-declarations */
import React from 'react';
import moment from 'moment';
import { Typography } from '@material-ui/core';

import CustomToolbar from '../../../common/CustomToolbar/CustomToolbar';
import globals from '../../../../globals/communityGlobals';
import _ from '../../../../utils/lodash';

const mapPropName = (columnName, isEntityToDto = false) => {
  const entityNames = ['Forename', 'Surname', 'StaffNumber', 'Username'];
  const dtoNames = ['forenames', 'surname', 'staffNumber', 'username'];
  if (isEntityToDto) {
    const index = _.indexOf(entityNames, columnName);
    return dtoNames[index];
  }
  const index = _.indexOf(dtoNames, columnName);
  return entityNames[index];
};

const setSortDirection = (columnDtoName, options) => {
  const entityName = mapPropName(columnDtoName, false);

  return entityName === options.sortColumn ? options.sortDirection : 'none';
};

export const tableSettings = options => {
  // const locale = options.eventHandlers.locale;
  const eventHandlers = options.eventHandlers;

  return {
    name: <Typography variant="h3">{eventHandlers.locale.getMsg('clinicianUsernameMapping')}</Typography>,
    columns: [
      {
        name: 'id',
        options: {
          display: 'excluded',
        },
      },
      {
        name: 'forenames',
        label: 'Forename',
        options: {
          sortOrder: {
            name: 'forenames',
            direction: setSortDirection('forenames', options),
          },
        },
      },
      {
        name: 'surname',
        label: 'Surname',
        options: {
          sortOrder: {
            name: 'surname',
            direction: setSortDirection('surname', options),
          },
        },
      },
      {
        name: 'staffNumber',
        label: 'Staff Number',
        options: {
          sortOrder: {
            name: 'staffNumber',
            direction: setSortDirection('staffNumber', options),
          },
        },
      },
      {
        name: 'username',
        label: 'Username',
        options: {
          sortOrder: {
            name: 'username',
            direction: setSortDirection('username', options),
          },
        },
      },
      {
        name: 'isMapped',
        label: 'Is Mapped',
        options: {
          sort: false,
          customBodyRender: (value, tableMeta) => {
            return tableMeta.rowData[4] ? '✔' : '-';
          },
        },
      },
      {
        name: 'usernameMappingTime',
        label: 'Mapping Date',
        options: {
          sort: false,
          customBodyRender: (value, tableMeta) => {
            return tableMeta.rowData[6] ? moment(value).format(globals.dateFormats.shortWithLongTime) : '-';
          },
        },
      },
    ],
    options: {
      filterType: 'dropdown',
      responsive: 'standard',
      selectableRows: 'none',
      rowsPerPageOptions: [5, 15, 30, 50, 100],
      rowsPerPage: options.pageSize,
      print: false,
      search: false,
      filter: false,
      serverSide: true,
      count: options.count,
      page: options.page,
      customToolbar: () => (
        <CustomToolbar
          eventHandlers={options.eventHandlers}
          isTableDataLoading={options.isTableDataLoading}
          hideActionButtons
        />
      ),
      onRowClick: rowData => eventHandlers.handleSidePanel(true, rowData),
      onTableChange: (action, tableState) => {
        switch (action) {
          case 'changePage':
          case 'changeRowsPerPage':
            options.eventHandlers.updateTableProps(tableState.page + 1, tableState.rowsPerPage);
            break;
          case 'sort':
            let sortColumn = '';
            let sortDirection = '';

            if (tableState.activeColumn > -1) {
              sortColumn = mapPropName(tableState.sortOrder.name);
              sortDirection = tableState.sortOrder.direction;
              options.eventHandlers.updateTableSort(sortColumn, sortDirection);
            }
            break;
          default:
            break;
        }
      },
    },
  };
};
